<template>
  <b-form-group
    id="input-group-1"
    label="Tipo de búsqueda  "
    label-for="formrow-inputState"
  >
    <b-form-select
      id="formrow-inputState"
      value=""
      v-model="type"
      :options="types"
      value-field="id"
      text-field="name"
      type="text"
    ></b-form-select>
  </b-form-group>
</template>

<script>
import { RAC, LOP } from "./lease_items";

export default {
  props: {
    value: String,
  },
  data() {
    return {
      type: this.value,
      types: RAC,
    };
  },
  beforeMount() {
    if (this.$route.name === "arriendosLop") {
      this.type = "contratoLop";
      this.types = LOP;
    }
    this.$emit("input", this.type);
    this.$emit("change", {});
  },
  watch: {
    type(newVal) {
      this.$emit("input", newVal);
      this.$emit("change", {});
    },
  },
};
</script>

<style>
</style>